var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState, useMemo, useEffect, useRef } from "react";
import { fusion } from "../fusion/fusion";
import { createRequestNumberGenerator } from "../utils/requestNumberGenerator";
import { createGetCanvas } from "../utils/getCanvas";
export function useFusion({ cimDoc, dimension, onError, onPaint, textOptions, selectors, getCanvas, filters, debugOptions, experimentalOptions, videoOptions, referrer, }) {
    const [loading, setLoading] = useState(false);
    const layoutRequestNumberGenerator = useMemo(() => createRequestNumberGenerator(), []);
    const getCanvasDefault = useMemo(() => createGetCanvas(), []);
    const canvassesRef = useRef(new Set());
    useEffect(() => {
        return () => {
            // Reset canvasses to release memory on umount
            // https://pqina.nl/blog/canvas-area-exceeds-the-maximum-limit/
            // Width and height has to be 1, not 0 for this to work
            // eslint-disable-next-line react-hooks/exhaustive-deps
            canvassesRef.current.forEach((canvas) => {
                canvas.width = 1;
                canvas.height = 1;
                const ctx = canvas.getContext("2d");
                ctx && ctx.clearRect(0, 0, 1, 1);
            });
        };
    }, []);
    useEffect(() => {
        if (selectors.length === 0) {
            return;
        }
        const animationFrame = window.requestAnimationFrame(() => __awaiter(this, void 0, void 0, function* () {
            let results;
            try {
                setLoading(true);
                results = yield fusion({
                    cimDoc,
                    dimension,
                    layoutRequestNumberGenerator,
                    selectors,
                    textOptions,
                    getCanvas: getCanvas !== null && getCanvas !== void 0 ? getCanvas : getCanvasDefault,
                    filters,
                    debugOptions,
                    experimentalOptions,
                    videoOptions,
                    referrer,
                });
            }
            catch (e) {
                onError(e);
            }
            // finally
            if (results) {
                // Save all canvasses used to the ref to clean them up later
                results.forEach(({ canvas, paintResultsOverprints }) => {
                    canvassesRef.current.add(canvas);
                    paintResultsOverprints === null || paintResultsOverprints === void 0 ? void 0 : paintResultsOverprints.forEach((overPrintResult) => {
                        canvassesRef.current.add(overPrintResult.canvas);
                    });
                });
                // results can be null when an other fusion request cancelled the previous one
                onPaint(results);
                setLoading(false);
            }
        }));
        return () => {
            window.cancelAnimationFrame(animationFrame);
        };
    }, [
        cimDoc,
        dimension,
        textOptions,
        onError,
        onPaint,
        layoutRequestNumberGenerator,
        selectors,
        getCanvas,
        filters,
        debugOptions,
        experimentalOptions,
        getCanvasDefault,
        videoOptions,
        referrer,
    ]);
    return { loading };
}
//# sourceMappingURL=useFusion.js.map